import * as _ from 'lodash'
import React, { useState } from 'react';
import componentServices from '../componentServices';
import { useJobCostItemDragDrop } from '../draggableJobCostLineItem';
import valueFilters from '../valueFilters';
import util from '../util';
import enums from '../enum';
import * as vendorActions from '../vendorActions'; import { CurrencyInput, Header, jobCostRowOwner, JobCostHiddenWhenLocked, PercentInput } from './sharedComponents';
import { getCollection, ModelCollection } from 'Scripts/store';

const _jobCostLineItemTypes = ['solid-surface-counter'];

const JobCostSSCTRow = (props) => {
	const { alwaysValidate, buttonHandler, classNames = [], draggable, buttonClass, dropLineItem, lineItem, updateModel, workAreas, vendors } = props;
	const [shouldValidate, setShouldValidate] = useState(alwaysValidate);
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef, rowRef}] = useJobCostItemDragDrop({ 
		item: lineItem,
		handleDrop: (dragItem, dropItem) => dropLineItem(dragItem.key, dropItem.key) 
	});

	function handleUpdate(path, autoSave, e) {
		e.preventDefault();

		const newVal = (autoSave) ? e.target.type === 'text' ? valueFilters.clean(e.target.value) : valueFilters.trim(e.target.value) : e.target.value;

		updateModel((model, updateCallback) => {
			model.setAt(path, newVal);

			updateCallback(model, path);
		}, { autoSave: autoSave });
	}

	function onCheckboxChange(path, autoSave, e) {
		const newVal = !!e.target.checked;

		updateModel((model, updateCallback) => {
			model.setAt(path, newVal);

			updateCallback(model, path);
		}, { autoSave: autoSave });
	}

	function validate(property?) {
		if (!property || shouldValidate) {
			const result = !lineItem.test(property);

			return result;
		}
		return true;
	}

	function handleButtonClick(e) {
		e.preventDefault();

		const valid = validate();

		if (!valid) {
			setShouldValidate(true)
		}
		else {
			// this assumes that the add handler succeeds
			setShouldValidate(alwaysValidate);
		}

		buttonHandler(valid, e);
	}

	let dropClass: any = null;
	const dragClass: any = isDragging ? 'disabled' : null;

	if (dropItem) {
		const dropIndex = lineItem.sortIndex;
		const dragIndex = dropItem.sortIndex;

		dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
	}

	const rowClasses = _.concat(classNames, dropClass, dragClass);

	let disableEntry = 'disabled';

	const workAreaOptions: JSX.Element[] = [];

	workAreaOptions.push(<option key="unknown" value="">Select</option>);
	_.forEach(workAreas, workArea => {
		workAreaOptions.push(<option key={workArea.key} value={workArea.key}>{workArea.name}</option>);
	});

	const vendorOptions: JSX.Element[] = [];

	vendorOptions.push(<option key="unknown">Select</option>);
	vendors.forEach(v => {
		vendorOptions.push(<option key={v.key} value={v.key}>{v.name}</option>);
	});

	if (lineItem.vendorKey) {
		disableEntry = '';
	}
	return <tr ref={ rowRef } className={rowClasses.join(' ')} key={'row-' + lineItem.key}>
		<td />
		<td className={(!validate('workAreaKey') ? 'required' : '')}>
			<select placeholder="Select" value={lineItem.viewValue('workAreaKey')} onChange={ e => handleUpdate('workAreaKey', true, e)}>
				{workAreaOptions}
			</select>
		</td>
		<td className={(!validate('vendorKey') ? 'required' : '')}>
			<select placeholder="Select" value={lineItem.viewValue('vendorKey')} onChange={ e => handleUpdate('vendorKey', true, e)}>
				{vendorOptions}
			</select>
		</td>
		<td className={' ' + (!validate('referenceNumber') ? 'required' : '')}><input className={disableEntry} type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" value={lineItem.viewValue('referenceNumber')} onChange={ e => handleUpdate('referenceNumber', false, e)} onBlur={ e => handleUpdate('referenceNumber', true, e)} /></td>
		<td className={' ' + (!validate('description') ? 'required' : '')}><textarea className={`lineItemDescription ${disableEntry}`} placeholder="Enter" value={lineItem.viewValue('description')} onChange={ e => handleUpdate('description', false, e)} onBlur={ e => handleUpdate('description', true, e)} readOnly={rowClasses.indexOf('readOnly') !== -1} /></td>
		<td className={'centered '}><input className={disableEntry} type="checkbox" checked={lineItem.isOptional} onChange={e => onCheckboxChange('isOptional', true, e)} /></td>
		<td className={'cost ' + ' ' + (!validate('cost') ? 'required' : '')}><CurrencyInput className={disableEntry} type="text" placeholder="0.00" value={lineItem.viewValue('cost')} onChange={ e => handleUpdate('cost', false, e)} onBlur={ e => handleUpdate('cost', true, e)} /></td>
		<td className={'margin ' + ' ' + (!validate('margin') ? 'required' : '')}><PercentInput className={disableEntry} type="text" placeholder="0.00" value={lineItem.viewValue('margin')} onChange={ e => handleUpdate('margin', false, e)} onBlur={ e => handleUpdate('margin', true, e)} /></td>
		<td className={'sell ' + ' ' + (!validate('sellPrice') ? 'required' : '')}><CurrencyInput className={disableEntry} type="text" placeholder="0.00" value={lineItem.viewValue('sellPrice')} onChange={ e => handleUpdate('sellPrice', false, e)} onBlur={ e => handleUpdate('sellPrice', true, e)} /></td>
		<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
		<td />
	</tr>;
}

const JobCostSSCTSection = jobCostRowOwner({ listAccessor: model => model.lineItems, listFilterThunkFactory: props => row => row.type === props.type }, class SSCSection extends React.Component<any, any> {
	constructor(props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.dropLineItem = this.dropLineItem.bind(this);
	}

	getStateFromProps(props) {
		const state = _.assign({}, this.state);

		if (!state.pendingLineItem || state.pendingLineItem.type !== props.type) {
			state.pendingLineItem = this.createPendingLineItem(props);
		}

		return state;
	}

	addLineItemHandler(lineItemKey, isValid) {
		if (!isValid) {
			return;
		}

		this.props.updateModel(model => {
			if (lineItemKey === this.state.pendingLineItem.key) {
				this.state.pendingLineItem.sortIndex = this.props.getNextSortIndex(model);
				model.lineItems.set(lineItemKey, this.state.pendingLineItem);
				this.props.sortRows(model);

				this.setState({ pendingLineItem: this.createPendingLineItem(this.props) });
			}
		}, { autoSave: true });
	}

	createPendingLineItem(props) {
		const { jobCost, type } = props;

		return jobCost.createLineItem({ type: type, margin: jobCost.margin });
	}

	updateModel(key, updater, options) {
		this.props.updateModel((jobCost, lineItemUpdateCallback) => {
			let lineItem = jobCost.lineItems.get(key);

			if ((!lineItem) && (key === this.state.pendingLineItem.key)) {
				lineItem = this.state.pendingLineItem;
				options.autoSave = false;
			}

			if (lineItem) {
				updater(lineItem, lineItemUpdateCallback);
			}
		}, options);
	}

	dropLineItem(sourceKey, targetKey) {
		this.props.updateModel(jobCost => {
			const sourceItem = jobCost.lineItems.get(sourceKey);
			const targetItem = jobCost.lineItems.get(targetKey);

			this.props.handleItemDrop(jobCost, sourceItem, targetItem);
		}, { autoSave: true });
	}

	render() {
		const { getRowClasses, jobCost, type, rowContextMenuHandler, summary, updateModel, ...childProps } = this.props;

		const lineItems = _.map(_.sortBy(jobCost.getLineItemsByType(type), 'sortIndex'), item => {
			return (
				<JobCostSSCTRow key={item.rowKey} updateModel={this.updateModel.bind(this, item.key)} dropLineItem={this.dropLineItem} buttonHandler={rowContextMenuHandler.bind(this, item)} lineItem={item} classNames={getRowClasses({ item: item })} buttonClass="icon iconOnly contextMenu" draggable={true} alwaysValidate={true} workAreas={jobCost.workAreas} {...childProps} />
			);
		});

		return (
			<section>
				<header />
				<div className="inner">

					<table className="compact" cellPadding="0" cellSpacing="0">
						<thead>
							<tr>
								<td />
								<td><span className="readOnly">Work Area</span></td>
								<td className="vendor"><span className="readOnly">Vendor</span></td>
								<td className="referenceNumber"><span className="readOnly">Reference No.</span></td>
								<td className="description"><span className="readOnly">Description</span></td>
								<td className="optional centered"><span className="readOnly">Optional</span></td>
								<td className="cost"><span className="readOnly">Cost</span></td>
								<td className="margin"><span className="readOnly">Margin %</span></td>
								<td className="cost"><span className="readOnly">Sell</span></td>
								<td className="action" />
								<td />
							</tr>
						</thead>
						<tbody>
							<JobCostHiddenWhenLocked jobCost={jobCost}><JobCostSSCTRow key={this.state.pendingLineItem.key} updateModel={this.updateModel.bind(this, this.state.pendingLineItem.key)} buttonHandler={this.addLineItemHandler.bind(this, this.state.pendingLineItem.key)} lineItem={this.state.pendingLineItem} classNames={['addRow']} buttonClass="icon iconOnly addItem" draggable={false} workAreas={jobCost.workAreas} {...childProps} /></JobCostHiddenWhenLocked>
							{lineItems}
						</tbody>
						<tfoot className="subtotal">
							<tr>
								<td />
								<td />
								<td className="cost" colSpan={5}>{_.startCase(type)} Subtotal</td>
								<td className="cost" colSpan={2}>{util.formatAsCurrency(summary.solidSurfaceCounterSellPrice)}</td>
								<td />
								<td />
							</tr>
						</tfoot>
					</table>
				</div>
			</section>
		);
	}
});

export default class JobCostEditSSCT extends React.Component<any, any> {
	constructor(props) {
		super(props);

		this.state = this.getStateFromProps();
	}

	UNSAFE_componentWillReceiveProps() {
		this.setState(this.getStateFromProps());
	}

	componentDidMount() {
		vendorActions.fetchCounterSuppliers();
	}

	getStateFromProps() {
		const { store } = componentServices;
		const state = _.assign({}, this.state);

		state.vendors = getCollection({ store, collection: ModelCollection.vendors}).filter(v => {
			return (v.type === enums.vendorTypes.Counter_Supplier);
		}).sortBy(v => v.name);

		return state;
	}

	render() {
		const { jobCost, summary } = this.props;
		const { vendors } = this.state;

		const sections = _.map(_jobCostLineItemTypes, type => {
			return (
				<JobCostSSCTSection key={type} updateModel={this.props.updateModel} jobCost={jobCost} summary={summary} vendors={vendors} type={type} />
			);
		});

		return (
			<section>
				<Header title="Solid Surface Counter" />
				<div className="jobCostSolidSurfaceCounter">
					{sections}
				</div>
			</section>
		);
	}
}